import {useLazyQuery} from '@apollo/client/react';
import {extractGqlData} from '@coolcolduk/ui-apollo-client';
import {Prompt} from '@cp/model';
import {GET_PDF_EXTRACT_QUESTION_PROMPT} from '../sharedQueries';

export function useGetPdfExtractQuestionPrompt() {
  const [getPdfExtractQuestionPromptQuery, {loading, error}] = useLazyQuery<
    {getPdfExtractQuestionPrompt: Prompt},
    {additionalInfo?: string}
  >(GET_PDF_EXTRACT_QUESTION_PROMPT);

  const getPdfExtractQuestionPrompt = async (additionalInfo?: string) => {
    const result = await getPdfExtractQuestionPromptQuery({
      variables: {additionalInfo: additionalInfo || undefined},
    });
    return extractGqlData(result).getPdfExtractQuestionPrompt;
  };

  return {
    getPdfExtractQuestionPrompt,
    loading,
    error,
  };
}
